import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      firstPaymentDate: periodFormat(filter.firstPaymentDate),
      nextBillingDate: periodFormat(filter.nextBillingDate),
      firstInvoiceAt: periodFormat(filter.firstInvoiceAt),
      plan: filter.plan[0] ? filter.plan : '*',
      healthStatus: filter.healthStatus[0] ? filter.healthStatus : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      status: filter.status[0] ? filter.status : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      country: filter.country[0] ? filter.country : '*',
      industry: filter.industry[0] ? filter.industry : '*',
      partnerType: filter.partnerType[0] ? filter.partnerType : '*',
      poc: filter.poc[0] ? filter.poc : '*',
      region: filter.region[0] ? filter.region : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      isTestTenant: filter.isTestTenant
        ? filter.isTestTenant === 'True'
          ? true
          : false
        : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerIds: filter.customerIds[0] ? filter.customerIds : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
